import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { DayRange } from '@api/types/dashboard'

interface DaysRangeSelectorProps {
  value: DayRange
  onChange: (value: DayRange) => void
}

const DAY_OPTIONS: DayRange[] = [7, 14, 30, 90]

export function DaysRangeSelector({ value, onChange }: DaysRangeSelectorProps) {
  const handleChange = (_: React.MouseEvent<HTMLElement>, newValue: DayRange | null) => {
    if (newValue !== null) {
      onChange(newValue)
    }
  }

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      size="small"
      aria-label="Days range"
    >
      {DAY_OPTIONS.map((days) => (
        <ToggleButton key={days} value={days} aria-label={`${days} days`}>
          {days}D
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}
